import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

import { ContextService } from 'src/core/services/context.service';

export class TaxonomyDataService extends DataService<typeof Model.General.Logic.ViewModels.TaxonomyItem, Model.General.Logic.ViewModels.TaxonomyItem, TaxonomyItem> {
	protected map(entity: Model.General.Logic.ViewModels.TaxonomyItem): TaxonomyItem {
		return new TaxonomyItemModel(entity);
	}

	static make(context?: ContextService): TaxonomyDataService {
		return new TaxonomyDataService(context, ctx => ctx.Taxonomies);
	}

	private id = -1;

	add(defaultLanguage: string): Promise<TaxonomyItem> {
		const entity = new Model.General.Logic.ViewModels.TaxonomyItem();
		entity.id = this.id--;
		(<any>entity).dynamicProperties = {
			displayName: {
				[defaultLanguage]: ''
			},
			taxonomyTags: [],
			type: 'text'
		};

		return this.create(() => entity);
	}
}

export class TaxonomyItemModel extends EntityModel<Model.General.Logic.ViewModels.TaxonomyItem, TaxonomyItem> implements TaxonomyItem {
	@property<TaxonomyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<TaxonomyItemModel>(o => o.entity.jsonSchemaDefinitionName, (o, value) => o.entity.jsonSchemaDefinitionName = value)
	public jsonSchemaDefinitionName: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: { [prop: string]: any };
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/form/taxonomy-form.data.ts